import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import {
  CompensationRootState,
  setIsFlaggedProposalsFilterApplied,
} from 'Deer/intent/Compensation/components/slice/compensationDrawersSlice';
import { useDispatch, useSelector } from 'react-redux';

import { CloseNav, MavenGlassesOff, MavenPositive } from 'assets/assetsV1/iconComponents';

import { BUTTON_VARIANT, Button } from 'uiToolkitV1/Button';
import { Divider } from 'uiToolkitV1/Divider';
import GradientButton from 'uiToolkitV1/GradientButton/GradientButton';
import { PaperWithShadow } from 'uiToolkitV1/Paper';
import { TagColored } from 'uiToolkitV1/Tag';
import BetaTag from 'uiToolkitV1/Tag/BetaTag';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const CompensationAnalysisMessage = () => {
  const dispatch = useDispatch();
  const isFlaggedProposalsFilterApplied = useSelector(
    (state: CompensationRootState) => state.compensationDrawers.isFlaggedProposalsFilterApplied
  );

  const handleViewFlaggedProposals = async () => {
    dispatch(setIsFlaggedProposalsFilterApplied(!isFlaggedProposalsFilterApplied));
  };

  return (
    <PaperWithShadow
      p="16px"
      bg="linear-gradient(91deg, rgba(0, 142, 240, 0.03) 1.81%, rgba(236, 59, 100, 0.03) 36.92%, rgba(255, 194, 0, 0.03) 69.52%, rgba(92, 196, 97, 0.03) 106.15%)"
      border="1px solid"
      borderColor="#B3D9FF"
      h="100%"
      display="flex"
      flexDirection="column"
    >
      {/* Header with title and status */}
      <Flex alignItems="center" justifyContent="space-between" mb="12px">
        <Flex alignItems="center" gap="8px">
          <MavenPositive boxSize="20px" />
          <TextBodyMedium bold>Compensation analysis</TextBodyMedium>
          <BetaTag />
        </Flex>
        <TagColored color="red">Needs review</TagColored>
      </Flex>

      {/* Divider below header */}
      <Divider color="neutral.EBEFF3" m="1px 0 12px 0" />
      <Box display="flex" flexDirection="column" gap="12px" justifyContent="space-between" flexGrow={1}>
        {/* Analysis description */}
        <TextBodyMedium color="#424242" mb="16px" lineHeight="1.5">
          Some proposals show mismatches between performance and pay increases. A few high performers have smaller
          raises than peers, while others with lower ratings are receiving above-average increases. There are also
          inconsistencies in compa ratios across teams, with some exceeding guidelines. Review flagged cases to ensure
          fairness and alignment with pay philosophy.
        </TextBodyMedium>

        {/* Action buttons */}
        <Flex gap="10px" height="40px">
          <GradientButton
            text="View flagged proposals"
            icon={MavenGlassesOff}
            onClick={handleViewFlaggedProposals}
            data-active={isFlaggedProposalsFilterApplied}
            isDisabled={isFlaggedProposalsFilterApplied}
          />
          {isFlaggedProposalsFilterApplied && (
            <Button
              variant={BUTTON_VARIANT.tertiary}
              StartIcon={CloseNav}
              color="red"
              onClick={handleViewFlaggedProposals}
            >
              Remove filter
            </Button>
          )}
        </Flex>
      </Box>
    </PaperWithShadow>
  );
};
